import {observer} from 'mobx-react-lite'
import React, {useMemo} from 'react'
import tw from 'tailwind-styled-components'
import {PermissionRoleKey} from 'yougile-model'
import {Checkbox} from '@components/common/base/checkbox'
import {DropdownList} from '@components/common/base/dropdown-list'
import {useForceUpdate} from '@containers/hooks'
import {useCompanyInvitePopupStore} from './company-invite-popup-store'
import {ProjectsListItem} from './types'

type ProjectListItemProps = {project: ProjectsListItem}

const TwSelectContainer = tw.div<{$enabled?: boolean}>`
  ml-auto
  max-w-200
  min-w-200

  ${p => (p.$enabled ? 'visible' : 'invisible')}
`

export const ProjectListItem = observer(({project}: ProjectListItemProps) => {
  const {id, title, enabled, roles, defaultRole} = project

  const [, store] = useCompanyInvitePopupStore()
  const forceUpdate = useForceUpdate()

  const onCheckboxChanged = (value: boolean) => {
    store.onEnabledChanged(id, value)
    forceUpdate()
  }
  const onRolesChanged = (value: PermissionRoleKey) => {
    store.onDefaultRoleChanged(id, value)
    forceUpdate()
  }

  const options = useMemo(() => {
    return roles.map(r => ({
      value: r.role,
      label: r.text
    }))
  }, [roles])

  return (
    <div className="flex items-center">
      <Checkbox
        value={enabled}
        text={title}
        onChange={onCheckboxChanged}
        className="overflow-hidden"
      />
      <TwSelectContainer $enabled={enabled}>
        <DropdownList
          link
          value={defaultRole}
          options={options}
          size={'small'}
          selectStyle={{width: 'fit-content'}}
          onChange={onRolesChanged}
        />
      </TwSelectContainer>
    </div>
  )
})
